import type { EventType, HtmlType, NameAndType } from '../../types.js'
import { jsonClass, jsonProperty } from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import {
	Expression,
	TextOrExpression_assumeExpression,
} from '../../data/text-or-code.js'
import { Block } from '../index.js'

@jsonClass('RichTextEditorBlock')
export class RichTextEditorBlock extends Block {
	@jsonProperty(TextOrExpression_assumeExpression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Label',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
	})
	labelCode = new TextOrExpression_assumeExpression('', 'T')

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 1,
		label: 'Binding',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: true,
		isMandatory: () => true,
	})
	bindingCode = new Expression()

	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 2,
		label: 'Placeholder text',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
	})
	placeholderCode = new Expression()

	constructor(init: Partial<RichTextEditorBlock> = {}) {
		super()
		this.init(init)
	}

	get allowedEventTypes(): EventType[] {
		return [{ name: 'keydown' }, { name: 'keyup' }, { name: 'change' }]
	}

	getValidationValueType(): string {
		return 'string'
	}

	canHaveChildren(): boolean {
		return false
	}

	canHaveValidators() {
		return true
	}

	canAcceptVariableString = (variable: NameAndType) => variable.type == 'string'
	acceptVariableString = (variable: NameAndType) =>
		(this.bindingCode = new Expression(variable.name))

	producePreview(): HtmlType {
		return `<textarea tabindex="-1" style="pointer-events: none;">${this.calculateExampleText()}</textarea>`
	}

	getEditorCategory(): string {
		return 'Additional Form Fields'
	}
}
